import React, { Fragment } from 'react';
import styled, { keyframes } from 'styled-components';
import '../../../log2base2.css';

export const SiteBtn = styled.button.attrs({ className: 'siteBtn' })`
  font-size: 15px;
  padding: 8px 16px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  outline: none;
  min-width: 90px;
  color: ${(props) => (props.darkTheme ? 'var(--btnDarkTxt)' : 'white')};
  background: ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'linear-gradient(135deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))')};
  :hover {
    filter: brightness(94%);
    outline: none;
  }
  :active {
    filter: initial;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const CourseThemeBtn = styled.button`
  font-size: 15px;
  padding: 8px 16px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  outline: none;
  min-width: 90px;
  color: white;
  background: ${({ courseTheme }) =>
    courseTheme === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : courseTheme === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : courseTheme === 'regionals'
      ? 'var(--regionalsColor)'
      : 'linear-gradient(135deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))'};
  :hover {
    filter: brightness(94%);
    outline: none;
  }
  :active {
    filter: initial;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const AnimatedBtn = styled(SiteBtn).attrs({ className: 'animatedBtn' })`
  padding: 12px 20px;
  background: ${(props) => props.active && 'linear-gradient(90deg, var(--gradientSecondaryColor), var(--gradientmiddleColor) 35%, var(--gradientPrimaryColor) 80%)'};
  background-position: ${(props) => props.active && 'right'};
  background-size: ${(props) => props.active && '300%'};
  animation: ${(props) => props.active && 'loadinggradient 4s ease-in-out infinite'};
  @keyframes loadinggradient {
    0% {
      background-position: right;
    }
    50% {
      background-position: left;
    }
    100% {
      background-position: right;
    }
  }
`;

export const FormBtn = styled(SiteBtn).attrs({ className: 'formBtn' })`
  width: 100%;
  padding: 10px 18px;
  min-width: 200px;
  color: ${(props) => (props.darkTheme ? 'var(--btnDarkTxt)' : 'white')};
  background: ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'linear-gradient(135deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))')};
`;

/* button shine effect */
const LeftOfferShine = keyframes`
0%{
  opacity: 0.6;
  transform: translateX(-100px) skewX(-15deg);
}
100% {    
  transform: translateX(300px)  skewX(-15deg);  
  opacity: 0.6;
}
`;
const RightOfferShine = keyframes`
0%{
  opacity: 0.1;
  transform: translateX(-100px) skewX(-15deg);
}
100% {  
  transform: translateX(300px) skewX(-15deg);  
  opacity: 1;
}
`;

const OfferShine = keyframes`
  100% {
    transform: translateX(480px) skewX(-20deg);
  }
`;

export const BannerBtn = styled(SiteBtn).attrs({ className: 'bannerBtn' })`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 320px) {
    width: 220px;
  }
  @media (min-width: 481px) {
    margin: 0px auto;
  }
  @media (min-width: 992px) {
    width: 240px;
    padding: 15px 20px;
    margin: 0px auto 0px 0px;
  }
`;

export const CourseThemeBannerBtn = styled(CourseThemeBtn)`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 320px) {
    width: 220px;
  }
  @media (min-width: 481px) {
    margin: 0px auto;
  }
  @media (min-width: 992px) {
    width: 240px;
    padding: 15px 20px;
    margin: 0px auto 0px 0px;
  }
  &::before {
    content: '';
    position: absolute;
    width: 35px;
    height: 70px;
    left: -60px;
    background-color: #ffffff42;
    filter: blur(15px);
    transform: skewX(-20deg);
    animation: ${OfferShine} 4.5s ease-in-out infinite;
  }
`;

export const SignupInfoBtn = styled(SiteBtn).attrs({ className: 'signUpInfoBtn' })`
  width: 210px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${({ from }) => from === 'partnerPlus' && 'var(--partnerPlusColor)'};
  @media (min-width: 320px) {
    width: 220px;
  }
`;

export const CtaBoxBtn = styled(SignupInfoBtn).attrs({ className: 'ctaBoxBtn' })`
  width: 210px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  color: var(--brandColor);
  @media (min-width: 320px) {
    width: 220px;
  }
  :hover {
    filter: brightness(97%);
    outline: none;
  }
  :active {
    filter: initial;
  }
`;

export const SecondaryBtn = styled(SiteBtn).attrs({ className: 'secondaryBtn' })`
  padding: 7px 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'var(--brandColor)')};
  background: transparent;
  border: 2px solid ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'var(--brandColor)')};
  &:hover,
  &:active {
    filter: initial;
    outline: none;
    background: ${(props) => (props.darkTheme ? '#2575fc0d' : 'var(--siteSecondaryBgColor)')};
  }
`;

export const GhostBtn = styled(SiteBtn).attrs({ className: 'ghostBtn' })`
  min-width: 90px;
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'var(--brandColor)')};
  background: transparent;
  &:hover,
  &:active {
    filter: initial;
    background: ${(props) => (props.darkTheme ? 'var(--blueShadowColor)' : 'var(--siteBorderColor)')};
  }
`;

export const PricingBarBtn = styled(SiteBtn).attrs({ className: 'pricingBarBtn' })`
  position: relative;
  overflow: hidden;
  padding: ${(props) => (props.isIndividualPricing ? '8px 4px' : '12px 4px')};
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  color: var(--inputTxtColor);
  background: #fcdd4c;
  @media (min-width: 360px) {
    padding: 12px 4px;
  }
  @media (min-width: 992px) {
    font-size: 15px;
  }
  &:before {
    content: '';
    display: block;
    position: absolute;
    background: rgba(255, 255, 255, 0.6);
    width: 60px;
    height: 100%;
    left: 0;
    top: 0;
    filter: blur(15px);
    animation: ${LeftOfferShine} 4.8s ease-in-out infinite;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    background: rgba(255, 255, 255, 0.4);
    width: 30px;
    height: 100%;
    left: 30px;
    top: 0;
    filter: blur(5px);
    animation: ${RightOfferShine} 4.8s ease-in-out infinite;
  }
`;

export const RoundedBtn = styled(SiteBtn).attrs({ className: 'roundedBtn' })`
  width: 100%;
  height: 100%;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ darkTheme }) => darkTheme && 'var(--btnDarkTxt)'};
  background: ${({ darkTheme }) => (darkTheme ? 'var(--brandColorDark)' : 'linear-gradient(180deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))')};
  border-radius: 25px;
`;

export const CourseThemeRoundedBtn = styled(CourseThemeBtn)`
  border-radius: 25px;
`;

export const SpinnerBtn = styled(SiteBtn).attrs({ className: 'spinnerBtn' })`
  width: 100%;
  height: 45px;
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DarkSiteBtn = styled(SiteBtn).attrs({ className: 'darkSiteBtn' })`
  color: ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'white')};
  background: ${(props) => (props.darkTheme ? 'var(--btnDarkBg)' : 'linear-gradient(135deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))')};
`;

export const ModalSecondaryBtn = styled(SiteBtn)`
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'var(--brandColor)')};
  background: transparent;
  border: 1px solid ${(props) => (props.darkTheme ? 'var(--brandColorDark)' : 'var(--brandColor)')};
  :hover {
    background: #2575fc0a;
    outline: none;
    filter: none;
  }
  :active {
    background: initial;
  }
`;

export default function SiteButton({
  formBtn,
  animatedBtn,
  bannerBtn,
  signUpInfoBtn,
  secondaryBtn,
  ghostBtn,
  pricingBarBtn,
  roundedBtn,
  spinnerBtn,
  ctaBoxBtn,
  darkBtn,
  modalSecondaryBtn,
  courseThemeBtn,
  courseThemeBannerBtn,
  isIndividualPricing,
  onClick,
  style,
  children,
  active,
  disabled,
  loadingText,
  id,
  ref,
  darkTheme,
  courseTheme,
  from,
}) {
  return (
    <Fragment>
      {bannerBtn ? (
        <BannerBtn id={id} onClick={onClick} style={style} from={from}>
          <span>{children}</span> <span className="fs-18 weight-600">&#10230;</span>
        </BannerBtn>
      ) : signUpInfoBtn ? (
        <SignupInfoBtn id={id} onClick={onClick} style={style} from={from}>
          <span>{children}</span> <span className="fs-18 weight-600">&#10230;</span>
        </SignupInfoBtn>
      ) : ctaBoxBtn ? (
        <CtaBoxBtn id={id} onClick={onClick} style={style}>
          <span>{children}</span> <span className="fs-18 weight-600">&#10230;</span>
        </CtaBoxBtn>
      ) : formBtn ? (
        <FormBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} darkTheme={darkTheme}>
          {children}
        </FormBtn>
      ) : animatedBtn ? (
        <AnimatedBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled}>
          {children}
        </AnimatedBtn>
      ) : secondaryBtn ? (
        <SecondaryBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </SecondaryBtn>
      ) : ghostBtn ? (
        <GhostBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </GhostBtn>
      ) : pricingBarBtn ? (
        <PricingBarBtn isIndividualPricing={isIndividualPricing} id={id} onClick={onClick} style={style} disabled={disabled}>
          {children}
        </PricingBarBtn>
      ) : roundedBtn ? (
        <RoundedBtn id={id} onClick={onClick} style={style} disabled={disabled} darkTheme={darkTheme}>
          {children}
        </RoundedBtn>
      ) : courseThemeBtn ? (
        <CourseThemeBtn id={id} onClick={onClick} style={style} from={from} courseTheme={courseTheme}>
          {children}
        </CourseThemeBtn>
      ) : courseThemeBannerBtn ? (
        <CourseThemeBannerBtn id={id} onClick={onClick} style={style} from={from} courseTheme={courseTheme}>
          <span>{children}</span> <span className="fs-18 weight-600">&#10230;</span>
        </CourseThemeBannerBtn>
      ) : spinnerBtn ? (
        <SpinnerBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className={`spinner-border spinner-border-sm thin-spinner-border ${darkTheme ? 'text-dark' : 'text-light'}`} role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </SpinnerBtn>
      ) : darkBtn ? (
        <DarkSiteBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </DarkSiteBtn>
      ) : modalSecondaryBtn ? (
        <ModalSecondaryBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </ModalSecondaryBtn>
      ) : (
        <SiteBtn id={id} onClick={onClick} style={style} disabled={disabled} darkTheme={darkTheme}>
          {children}
        </SiteBtn>
      )}
    </Fragment>
  );
}
